import React, { useEffect, useState } from 'react';
import { navigateAction } from 'fluxible-router';

import PitC from './pitc/pitc';
import {
  ABOVE_THE_CONVERSATION,
  DOUBLE_DECKER_KEY,
  PITC_KEY,
  PITC_LOCATION_KEY
} from './constants/products-constants';

import useSpotConfig from '@host-panel/request/config/use-config';

type Props = {
  spotId: string;
  spotName: string;
};

export const Products: React.FC<Props> = ({ spotId, spotName }) => {
  const [configValues, setConfig, { loading, errorFetching, errorSaving, saving }] = useSpotConfig(
    [PITC_KEY, PITC_LOCATION_KEY, DOUBLE_DECKER_KEY],
    {
      [PITC_KEY]: false,
      [PITC_LOCATION_KEY]: ABOVE_THE_CONVERSATION,
      [DOUBLE_DECKER_KEY]: false
    }
  );
  const [isPitcEnabled, setIsPitcEnabled] = useState<boolean>(false);
  const [pitcLocation, setPitcLocation] = useState<string>(ABOVE_THE_CONVERSATION);
  const [isDoubleDeckerEnabled, setIsDoubleDeckerEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (!loading) {
      const [pitc, pitcLocationValue, doubleDecker] = configValues;
      setIsPitcEnabled(pitc);
      setPitcLocation(pitcLocationValue);
      setIsDoubleDeckerEnabled(doubleDecker);
    }
  }, [loading]);

  const onSettingsClick = () => {
    const url = `/spot/${spotId}/preferences/super-admin/settings`;
    // @ts-ignore
    context.executeAction(navigateAction, { url });
  };

  const saveSettings = () => {
    setConfig(
      [
        { key: PITC_KEY, value: isPitcEnabled },
        { key: PITC_LOCATION_KEY, value: pitcLocation },
        { key: DOUBLE_DECKER_KEY, value: isDoubleDeckerEnabled }
      ],
      spotName
    );
  };

  // Can't enable double decker while pitc is off
  const onPitcChange = (isEnabled: boolean) => {
    setIsPitcEnabled(isEnabled);
    if (!isEnabled) {
      setIsDoubleDeckerEnabled(false);
    }
  };

  const onDoubleDeckerChange = (isEnabled: boolean) => {
    setIsDoubleDeckerEnabled(isEnabled);
    if (isEnabled) {
      setIsPitcEnabled(true);
    }
  };

  if (errorFetching || errorSaving) {
    return (
      <div className="error-container">
        <span className="error-warning">Something wen’t wrong, please try again.</span>
      </div>
    );
  }

  return saving ? (
    <div className="loading" />
  ) : (
    <section className="products">
      <div className="dashboard-filter">
        <span className="filter" onClick={onSettingsClick}>
          Settings
        </span>
        <span className="filter active">Products</span>
      </div>
      <PitC
        isEnabled={isPitcEnabled}
        setIsEnabled={onPitcChange}
        isDoubleDeckerEnabled={isDoubleDeckerEnabled}
        setIsDoubleDeckerEnabled={onDoubleDeckerChange}
        location={pitcLocation}
        setLocation={setPitcLocation}
      />

      <button onClick={saveSettings} className="policy-button">
        Save changes
      </button>
    </section>
  );
};
